import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import routes from '../../utils/routes';
import strings from '../../utils/strings';
import { CButton, CInput, CText, CHeader } from '../../components/common';
import { emailValidation } from '../../utils/validation';

const SignUp: React.FC = () => {
  const navigate = useNavigate();
  const colors = useAppSelector((state) => state.theme.theme);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const handleSignUp = () => {
    let isValid = true;

    if (!fullName) {
      setNameError(strings.thisFieldIsMandatory);
      isValid = false;
    } else {
      setNameError('');
    }

    if (!email) {
      setEmailError(strings.thisFieldIsMandatory);
      isValid = false;
    } else if (!emailValidation(email)) {
      setEmailError(strings.enterValidEmail);
      isValid = false;
    } else {
      setEmailError('');
    }

    if (!password) {
      setPasswordError(strings.plsEnterPassword);
      isValid = false;
    } else if (password.length < 8) {
      setPasswordError(strings.enterStrongPassword);
      isValid = false;
    } else {
      setPasswordError('');
    }

    if (!confirmPassword) {
      setConfirmPasswordError(strings.plsEnterPassword);
      isValid = false;
    } else if (password !== confirmPassword) {
      setConfirmPasswordError(strings.confirmPassValidString);
      isValid = false;
    } else {
      setConfirmPasswordError('');
    }

    if (isValid) {
      // Implement sign up logic here
      navigate(routes.home);
    }
  };

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      <CHeader title={strings.signUp} />

      {/* Responsive container */}
      <div className="max-w-md md:max-w-lg lg:max-w-xl mx-auto px-5 py-4">
        <h2
          className="text-2xl md:text-3xl font-bold mb-2"
          style={{ color: colors.textColor }}
        >
          {strings.createYourAccount}
        </h2>
        <CText type="r14" color={colors.grayScale500} style={{ marginBottom: '16px' }}>
          {strings.accountText}
        </CText>

        <CInput
          label={strings.fullName}
          value={fullName}
          onChange={setFullName}
          placeholder="Enter your full name"
          errorText={nameError}
          required
        />

        <CInput
          label={strings.email}
          value={email}
          onChange={setEmail}
          placeholder="Enter your email"
          type="email"
          errorText={emailError}
          required
        />

        <CInput
          label={strings.password}
          value={password}
          onChange={setPassword}
          placeholder="Enter your password"
          isSecure
          errorText={passwordError}
          required
        />

        <CInput
          label={strings.confirmPassword}
          value={confirmPassword}
          onChange={setConfirmPassword}
          placeholder="Confirm your password"
          isSecure
          errorText={confirmPasswordError}
          required
        />

        <div className="mt-2 mb-2">
          <CText type="r12" color={colors.grayScale500}>
            {strings.agreementText} {' '}
            <span className="cursor-pointer" style={{ color: colors.primary }}>
              {strings.userAgreement}
            </span>
            {' '}{strings.and}{' '}
            <span
              className="cursor-pointer"
              style={{ color: colors.primary }}
              onClick={() => navigate(routes.privacyPolicies)}
            >
              {strings.privacyPolicy}
            </span>
          </CText>
        </div>

        <CButton title={strings.signUp} onPress={handleSignUp} />

        <div className="text-center mt-4">
          <CText type="r14" color={colors.grayScale500}>
            {strings.alreadyHaveAccount}
            <span
              className="cursor-pointer ml-1"
              style={{ color: colors.primary }}
              onClick={() => navigate(routes.login)}
            >
              {strings.signIn}
            </span>
          </CText>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
